import { Component, Renderer2, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ImpersonationService } from './core/impersonation-service';
import { ImpersonationStatus } from './core/impersonation-status';
import { UIBlockingService } from './core/ui-blocking.service';

@Component({
    selector: 'app-admin-portal-base',
    templateUrl: './admin-portal-base.component.html',
    styleUrls: ["../assets/js/plugins/datatables/datatables.min.css",
        "../../node_modules/@mobiscroll/angular/dist/css/mobiscroll.min.css",
        "../../node_modules/ngx-toastr/toastr.css",
        "../assets/css/admin-style.css",
        "../assets/css/overrides.css"],
    encapsulation: ViewEncapsulation.None
})
export class AdminPortalBaseComponent {
    hideSidebar: boolean = true;
    hideHeader: boolean = true;
    title = 'Indy Chamber';
    sidebarToggled = false;
    impersonating = false;
    impersonatedContactName = "";
    mobileMenuOpen = false;

    constructor(private router: Router,
        private renderer: Renderer2, private impersonationService: ImpersonationService, private blockUI: UIBlockingService) {
        router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChange());
    }
    ngOnInit() {
        this.handleRouteChange();

    }

    handleRouteChange = () => {
        this.impersonating = localStorage.getItem("impersonating") == "true";
        this.impersonatedContactName = localStorage.getItem("impersonatedContactName");
        var storedToggleValue = localStorage.getItem('sidebarToggled');
        if (storedToggleValue != this.sidebarToggled.toString() && storedToggleValue != null) {
            this.sidebarToggled = !this.sidebarToggled;
        }
        if (this.impersonating && this.router.url.includes("chamber")) {
            this.endImpersonation(this.router.url);
        }

        if (this.sidebarToggled) {
            this.renderer.addClass(document.body, 'sb-sidenav-toggled');
        }
        else {
            this.renderer.removeClass(document.body, 'sb-sidenav-toggled');
        }
        if (this.mobileMenuOpen) {
            this.onMobileMenuToggle();
        }

        this.renderer.removeClass(document.body, 'login');
        this.renderer.removeClass(document.body, 'error');

        if (this.router.url.includes('login') || this.router.url.includes('reset-password')) {
            this.hideSidebar = true;
            this.hideHeader = true;
            this.renderer.addClass(document.body, 'login');
            //this.renderer.removeClass(document.getElementById("site-wrapper"), 'site-wrap');
            //this.renderer.removeClass(document.body, 'moderation');
        }
        else if (this.router.url.includes('sign-up')) {
            this.hideSidebar = true;
            this.hideHeader = true;
            this.renderer.addClass(document.body, 'create');
        }
        else if (this.router.url.includes('page-not-found')) {
            this.hideSidebar = true;
            this.hideHeader = true;
            this.renderer.addClass(document.body, 'error');
        }
        else {
            this.renderer.removeClass(document.body, 'moderation');
            this.hideSidebar = false;
            this.hideHeader = false;
        }
    };

    onMobileMenuToggle() {
        this.sidebarToggled = !this.sidebarToggled;
        this.mobileMenuOpen = !this.mobileMenuOpen;
        localStorage.setItem('sidebarToggled', this.sidebarToggled.toString());
        if (this.sidebarToggled) {
            this.renderer.addClass(document.body, 'sb-sidenav-toggled');
        }
        else {
            this.renderer.removeClass(document.body, 'sb-sidenav-toggled');
        }

    }

    endImpersonation(url): void {
        if (this.impersonating) {
            this.blockUI.start();
            this.impersonationService.endImpersonation().subscribe({
                next: (status) => {
                    this.impersonationService.impersonationStatus.next(status);
                    localStorage.setItem('userFirstName', status.userFirstName);
                    localStorage.setItem('userLastName', status.userLastName);
                    localStorage.setItem('contactId', status.contactId);
                    localStorage.setItem('contactType', status.contactType);
                    localStorage.setItem('userEmailAddress', status.userEmailAddress);
                    localStorage.setItem('impersonating', "false");
                    this.impersonating = false;

                    this.router.navigate([url]).then(() => {
                        window.location.reload();
                        this.blockUI.stop();
                    });
                },
            });
        }
    }
}
